import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'pop';
}

export function Card({ children, className = '', variant = 'pop' }: CardProps) {
  const baseStyles = 'transition-all duration-200 relative';
  const variantStyles = {
    default: 'card-pop', // Fallback to pop
    pop: 'card-pop',
  };

  return (
    <div className={`${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`}>
      {children}
    </div>
  );
}
